/**
 * Types utilisateur selon le nouveau schéma unifié backend
 * User remplace Client + Partner dans un modèle unifié
 * ALIGNÉ AVEC LE SCHÉMA PRISMA BACKEND
 */

import { Contact } from './contact';

// Interface User selon le nouveau schéma unifié backend
export interface User {
  id: number;
  firebaseId: string;             // Correspond à firebaseId dans Prisma
  email: string;
  name: string;
  role: Role;
  
  // Nouveau schéma unifié (remplace Client + Partner) - ALIGNÉ AVEC PRISMA
  type: UserType;
  status: UserStatus;
  
  // Champs optionnels pour partenaires/clients
  country?: string | null;
  currency?: string | null;
  website?: string | null;
  onboardedAt?: string | null;
  
  // Timestamps
  createdAt: string;
  
  // Relations
  networks?: string[];  // Array de noms de réseaux (ex: ["CultureG", "Freestar"])
  contacts?: Contact[];  // Contacts associés à cet utilisateur
  
  // Statistiques calculées (optionnelles, présentes dans les listes)
  contactsCount?: number;
  tasksCount?: {
    owned: number;
    assigned: number;
  };
}

// Enums ALIGNÉS avec le schéma Prisma backend
export enum Role {
  ADMIN = 'ADMIN',
  CLIENT = 'CLIENT', 
  PARTNER = 'PARTNER'
}

export enum UserType {
  REGIE = 'REGIE',
  GROUPE = 'GROUPE',
  INDEPENDANT = 'INDEPENDANT',
  VENDOR = 'VENDOR',
  SUPPLIER = 'SUPPLIER',
  RESELLER = 'RESELLER',
  AGENCY = 'AGENCY',
  OTHER = 'OTHER'
}

export enum UserStatus {
  PROSPECT = 'PROSPECT',
  ONBOARDING = 'ONBOARDING',
  ACTIVE = 'ACTIVE',
  TERMINATED = 'TERMINATED',
  INACTIVE = 'INACTIVE'
}

// Interface pour la création d'utilisateur
export interface CreateUserRequest {
  firebaseId: string;
  email: string;
  name: string;
  role: Role;
  type: UserType;
  status: UserStatus;
  country?: string | null;
  currency?: string | null;
  website?: string | null;
}

// Interface pour la mise à jour d'utilisateur
export interface UpdateUserRequest {
  name?: string;
  role?: Role;
  type?: UserType;
  status?: UserStatus;
  country?: string | null;
  currency?: string | null;
  website?: string | null;
}

// Type pour la création/mise à jour d'utilisateurs (formulaires)
export interface UserFormData {
  email: string;
  name: string;
  role: Role;
  type: UserType;
  status: UserStatus;
  country?: string | null;
  currency?: string | null;
  website?: string | null;
  password?: string;
}

// Interface pour l'affichage dans les listes
export interface UserListItem {
  id: number;
  name: string;
  email: string;
  role: Role;
  type: UserType;
  status: UserStatus;
}

// Interface pour les sélecteurs de contact
export interface UserForContact {
  id: number;
  name: string;
  email: string;
  type: UserType;
}

// Informations d'authentification
export interface AuthState {
  user: User | null;
  loading: boolean;
  error: string | null;
}

// Helper functions pour les conversions d'ID
export const toNumberId = (id: string | number): number => 
  typeof id === 'string' ? parseInt(id, 10) : id;

export const toStringId = (id: string | number): string => 
  typeof id === 'number' ? id.toString() : id;

// Types pour compatibilité avec l'ancien schéma (à supprimer progressivement)
export type Client = User & { type: UserType.REGIE | UserType.GROUPE | UserType.INDEPENDANT };
export type Partner = User & { type: UserType.VENDOR | UserType.SUPPLIER | UserType.RESELLER | UserType.AGENCY };
